import React from 'react';

import { di } from 'react-magnetic-di';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditUrlInput } from './edit';
import { PreviewUrlInput } from './preview';
import { ViewUrlInput } from './view';

export const UrlInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormRenderMode);
	const renderMode = useFormRenderMode();

	if (renderMode === FormRenderMode.EDIT) {
		return (
			<EditUrlInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	if (renderMode === FormRenderMode.PREVIEW) {
		return (
			<PreviewUrlInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	return (
		<ViewUrlInput
			fieldId={fieldId}
			fieldInputId={fieldInputId}
			fieldLabelId={fieldLabelId}
			fieldErrorId={fieldErrorId}
		/>
	);
};
